<template>
  <section class="world-background-green">
    <cards-roulette v-bind:options="options" :type="'economic_sectors'" />
  </section>
</template>

<script>
import EconomicSectors from '@/constants/economic_sectors.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'

export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.options = EconomicSectors
  }
}
</script>
